import { useContext, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { addNode } from "../utils/flowSlice";
import { GrDocument, GrDocumentText } from "react-icons/gr";
import axios from "./../utils/axiosInstance";
import { DarkModeContext } from "../context/DarkModeContext";
const Document = () => {
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // Create FormData object to send file
      const formData = new FormData();
      formData.append("file", file);

      // Send the file to your backend for processing
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASED_URL}/service/document`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }, // Explicitly set the Content-Type
          }
        );

        if (!!response) {
          const script = response.data;
          // console.log("Backend response:", script);

          // Dispatch any node updates or handle backend response here
          dispatch(
            addNode({
              type: "documentNode",
              file: file.name,
              script: script,
            })
          );
        } else {
          const script = "I can't read content";
          // console.log("Backend response:", script);

          // Dispatch any node updates or handle backend response here
          dispatch(
            addNode({
              type: "documentNode",
              file: file.name,
              script: script,
            })
          );
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        const script = "I can't read content";
        // console.log("Backend response:", script);

        // Dispatch any node updates or handle backend response here
        dispatch(
          addNode({
            type: "documentNode",
            file: file.name,
            script: script,
          })
        );
      }
    }
  };
  const { darkMode } = useContext(DarkModeContext);

  // State to track hover for each icon
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleMouseEnter = (id) => {
    setActiveTooltip(id);
  };

  const handleMouseLeave = () => {
    setActiveTooltip(null);
  };

  return (
    <div
      className="rounded-lg flex justify-center items-center relative hover:cursor-pointer"
      onMouseEnter={() => handleMouseEnter("doc")}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={`w-10 h-10 mt-0.5 mx-0.5 flex items-center justify-center rounded-full transition opacity-50 ${
          darkMode ? "text-neutral-600" : "text-white"
        }`}
        onClick={handleButtonClick}
      >
        <GrDocument size={20} />
      </button>
      {activeTooltip === "doc" && (
        <span className="absolute left-full ml-2 whitespace-nowrap bg-gray-700 text-white text-xs rounded py-1 px-2 z-10">
          Document ( PDF, TXT, DOCX, XLSX ... )
        </span>
      )}
      <input
        ref={fileInputRef}
        accept=".pdf, .txt, .docx, .odt, .xlsx, .pptx "
        type="file"
        className="hidden"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default Document;
